import { PageTitle } from 'src/ui/shared/components/page-components/PageTitle';
import { useRootSelector } from 'src/ui/shared/hooks/root-selector.hook';

export const CentralPublishTitle = (): React.ReactElement<any, any> | null => {
    const central = useRootSelector(state => state.strings.careerHubStrings.central);

    return <PageTitle>Publish to {central}</PageTitle>;
};
